<template>
  <div>
    <b-modal
      id="modal-delete"
      size="md"
      centered
      :title="$store.state.modal.perhatian"
      header-bg-variant="danger"
      header-text-variant="light"
    >
      <p>Apakah anda yakin akan menghapus data ini ?</p>

      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-delete')">
          {{ $store.state.form.tidak }}
        </b-button>
        <b-button variant="primary" @click="hapus()"> {{ button }} </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "modalDelete",
  props: ["data"],
  data() {
    return {
      busy: false,
      button: "Ya",
    };
  },
  computed: {
    ...mapGetters(["lang"]),
  },
  methods: {
    hapus() {
      let vm = this;
      vm.button = this.$store.state.form.tunggu;
      vm.$axios
        .post("pengajuanLembur/delete", {id: vm.data.pengajuanLemburId})
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = vm.$store.state.form.ya;
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "success",
              msg: "BERHASIL MENGHAPUS DATA PENGAJUAN LEMBUR",
              showing: true,
            });
            this.$bvModal.hide("modal-delete");
          } else {
            vm.button = vm.$store.state.form.ya;
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
          }
        })
        .catch((err) => {
          vm.button = vm.$store.state.form.ya;
          vm.busy = false;
          vm.$emit("alertFromChild", {
            variant: "danger",
            msg: err.message.toUpperCase(),
            showing: true,
          });
        });
    },
  },
  watch: {
    lang: function (val) {
      val;
      this.button = this.$store.state.form.ya;
    },
  },
};
</script>
